import BasicRouterView from "../../../components/BasicRouterView.vue";

const notaFiscalRoutes = {
  path: "nf",
  redirect: { name: "nf-lista" },
  meta: {
    label: "Nota Fiscal",
    icon: "text_snippet",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "nota-fiscal/lista",
      name: "nf-lista",
      meta: {
        label: "Lista de Notas",
        icon: "text_snippet",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/ListaNotaFiscal.vue"),
    },
    {
      path: "nota-fiscal/entrada",
      name: "nf-entrada",
      meta: {
        label: "Entrada",
        icon: "door_front",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/Entrada.vue"),
    },
    {
      path: "nota-fiscal/listagem-entradas",
      name: "nf-listagem-entradas",
      meta: {
        label: "Listagem Entrada de NFs",
        icon: "list_alt",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/ListagemConsultaNotaFiscal.vue"
        ),
    },
    {
      path: "nota-fiscal/editar-nota/:notaId",
      name: "nf-editar",
      meta: {
        label: "Entrada",
        icon: "door_front",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/EditarNota.vue"),
    },
    {
      path: "nota-fiscal/entrada-manual",
      name: "nf-entrada-manual",
      meta: {
        label: "Entrada Manual",
        icon: "meeting_room",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/EntradaManual.vue"),
    },
  ],
};

export default notaFiscalRoutes;
